export default "/images/d077e10827861b73440bff3c5661c2e2.avif";